import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TestsuiteListenerService {

  @Output() testSuiteListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.testSuiteListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        }
    );
  }
}
